import inWords from "Utils/inWords";
import config from "Config";
// const TableHeaderMappings = require("./table-header-mappings.csv").reduce(
//   (memo, r) => {
//     if (r["old_name"]) {
//       memo[r["old_name"]] = r["new_name"];
//       return memo;
//     }
//   },
//   {}
// );
const TableHeaderMappings = {
  age5p_age_in_five_year_groups: "Age group",
  ancp_ancestry_multi_response: "Ancestry",
  born_in_australia: "Birthplace Australia",
  bplp_country_of_birth_of_person: "Country of birth",
  cdcf_main: "Family composition and number of children",
  citp_australian_citizenship: "Citizenship status",
  english_spoken_at_home: "Language spoken at home",
  engp_proficiency_in_spoken_english: "Proficiency in English",
  fmcf_family_composition: "Family Composition",
  fmcf_main: "Family Composition",
  hind_total_household_income_weekly: "Weekly income band",
  incp_total_personal_income_weekly: "Income band",
  ingp_indigenous_status: "Indigenous status",
  irsd_deciles_at_lga_level_pop: "SEIFA decile",
  lanp_language_spoken_at_home: "Language spoken at home",
  lfhrp_labour_force_status_and_hours_worked_not: "Labour force status",
  lower_range: "Income band's lower range ($)",
  main_english_speaking: "Birthplace main English speaking (MES) country ",
  nedd_type_of_internet_connection: "Type of internet connection",
  nprd_number_of_persons_usually_resident_in_dwe:
    "Number of persons usually, resident",
  number: "Count",
  numerical_year_of_arrival: "Year of arrival",
  occp_main: "Occupation",
  qallp_main: "Non-school qualification",
  relp_1: "Religious affiliation",
  relp_religious_affiliation: "Religious affiliation",
  sexp_sex: "Gender",
  tystap_educational_institution_attendee_status: "Educational institution",
  workage10: "Age group"
};

const community_table_suffixes_lookup = {
  Ancestry: "ancp",
  Birthplace: "birthpl",
  Language: "langhome",
  Religion: "relp"
};

const community_columns_lookup = {
  Ancestry: "ancp_ancestry_multi_response",
  Birthplace: "bplp_country_of_birth_of_person",
  Language: "lanp_language_spoken_at_home",
  Religion: "relp_religious_affiliation"
};

const community_columns_lookup_v2 = {
  Ancestry: "dlgc_cat",
  Birthplace: "dlgc_cat",
  Language: "dlgc_cat",
  Religion: "dlgc_cat"
};

const community_columns = Object.values(community_columns_lookup);

const communities = Object.keys(community_table_suffixes_lookup).map(
  ([first, ...tail]) => first.toUpperCase() + tail.join("")
);

const community_table_suffixes = Object.values(community_table_suffixes_lookup);

// create a standardized geo_aggregations_lookup:
const geo_aggregations_lookup = {
  ste: `all of ${config.admin_state_name.toLowerCase()}`,
  lga: "local government area",
  sed: "electoral division"
};

const boundaries_lookup = (year, geo_aggregation) =>
  `${geo_aggregation}_${year}_${config.admin_state_acronym.toLowerCase()}_boundaries`;

const community_table_prefixes_lookup = (year, geo_aggregation) =>
  `${config.cartodb_username}_${year}_${geo_aggregation}_cult_`;

const geo_aggregations_column_lookup = (year, geo_aggregation) =>
  ({
    ste: `ste_name${year.slice(2, 4)}`,
    lga: `lga_name${config.lga_boundary_year[year]}`, // TODO: hack for https://github.com/geografia-au/dlgrma/issues/15#issuecomment-514973121
    sed: `sed_name${
      config.cartodb_username === "dlgrma" ? config.sed_boundary_year[year] : ""
    }` // TODO Hack for https://github.com/geografia-au/dlgrma/issues/15#issuecomment-515111997
    // TODO: put back year at the end of sed_name after https://github.com/geografia-au/J0259-dlgrma_pipeline/issues/10
  }[geo_aggregation]);

const community_aggregation_lookup = {
  Ancestry: "ance",
  Birthplace: "birt",
  Religion: "relg",
  Language: "lote"
};

const geo_aggregation_value_column_lookup = (year, geo_aggregation) =>
  ({
    ste: "",
    lga: `local_government_areas_${year}_boundaries_ur`,
    sed: "state_electoral_divisions_ur"
  }[geo_aggregation]);

const isGeoAggregation = (aggregation, str) => {
  return geo_aggregations_lookup[aggregation] == str.toLowerCase();
};

// FIXME: this isn't really a lookup. It's part of the query string. need to think of a better place for this.
// possibly make a function given the range and step
// returns the bins
const ageBins = [
  "age5p_age_in_five_year_groups='0-4 years'",
  "age5p_age_in_five_year_groups='5-9 years'",
  "age5p_age_in_five_year_groups='10-14 years'",
  "age5p_age_in_five_year_groups='15-19 years'",
  "age5p_age_in_five_year_groups='20-24 years'",
  "age5p_age_in_five_year_groups='25-29 years'",
  "age5p_age_in_five_year_groups='30-34 years'",
  "age5p_age_in_five_year_groups='35-39 years'",
  "age5p_age_in_five_year_groups='40-44 years'",
  "age5p_age_in_five_year_groups='45-49 years'",
  "age5p_age_in_five_year_groups='50-54 years'",
  "age5p_age_in_five_year_groups='55-59 years'",
  "age5p_age_in_five_year_groups='60-64 years'",
  "age5p_age_in_five_year_groups='65-69 years'",
  "age5p_age_in_five_year_groups='70-74 years'",
  "age5p_age_in_five_year_groups='75-79 years'",
  "age5p_age_in_five_year_groups='80-84 years'",
  "age5p_age_in_five_year_groups='85-89 years'",
  "age5p_age_in_five_year_groups='90-94 years'",
  "age5p_age_in_five_year_groups='95-99 years'",
  "age5p_age_in_five_year_groups='100 years and over'"
];

const getAgeBinsOrderSQL = (range = [0, 100], step = 5, order = "ASC") => {
  let next = range[0];
  let binsSql = [];

  while (next < range[1]) {
    binsSql.unshift(
      `age${step}p_age_in_${inWords(step)}_year_groups='${next}-${next +
        step -
        1} years'`
    );
    next = next + step;
  }

  binsSql.unshift(
    `age${step}p_age_in_${inWords(step)}_year_groups='${next} years and over'`
  );

  if (order == "DESC") binsSql = binsSql.reverse();

  return binsSql.join(", ");
};

// const maxBounds = [
//   [-12.328259677742766,131.33056640625003],
//   [-35.335293203093286, 113.92822265625]
// ];
const { first, second } = config.map_coords;
const maxBounds = [
  [first.lat, first.long],
  [second.lat, second.long]
];

// TODO: write a generic sorter that takes an array of values, attributes
// sorts by index in values of the attribute's value
// this will replace th need to sort in SQL e.g. CATEGORY_RESIDENTS_IN_DWELLING
const sortByValues = (values, attr, order = "asc") => (a, b) => {
  return [];
};

const sortAgeGroups = attr => (a, b, order = "asc") => {
  if (order === "desc") {
    return b[attr].match(/(\d+)/)[0] - a[attr].match(/(\d+)/)[0];
  } else {
    return a[attr].match(/(\d+)/)[0] - b[attr].match(/(\d+)/)[0];
  }
};

module.exports = {
  ageBinsReverse: ageBins.reverse().join(", "),
  communities,
  community_aggregation_lookup,
  boundaries_lookup,
  geo_aggregations_lookup,
  geo_aggregations_column_lookup,
  geo_aggregation_value_column_lookup,
  community_table_suffixes_lookup,
  community_columns_lookup,
  community_columns_lookup_v2,
  community_table_prefixes_lookup,
  isGeoAggregation,
  getAgeBinsOrderSQL,
  maxBounds,
  TableHeaderMappings,
  sortAgeGroups
};



// WEBPACK FOOTER //
// ../data/lookups.js